export const filterSingleQuoteDocs = (doc, quoteId, paymentFrequency) => {
  paymentFrequency = paymentFrequency || "monthly";
  return (
    (doc.Code === "terms" && doc.QuoteId === quoteId) ||
    (doc.Code === "ipid" && doc.QuoteId === quoteId) ||
    (doc.Code === "factfindsdn" && doc.QuoteId === quoteId) ||
    (doc.Code === "quote" &&
      doc.QuoteId === quoteId &&
      doc.Criteria.PaymentFrequency === paymentFrequency.toLowerCase())
  );
};

export const filterMultiQuoteDocs = (doc, selectedAds) => {
  if (
    !doc.QuoteId &&
    (doc.Code === "terms" || doc.Code === "ipid" || doc.Code === "factfindsdn")
  )
    return true;

  if (doc.Code === "multiquote") {
    if (!doc.Criteria) return false;

    const correctForContents =
      doc.Criteria.ContentsAD === undefined ||
      doc.Criteria.ContentsAD === selectedAds.contentsAd;

    const correctForBuildings =
      doc.Criteria.BuildingsAD === undefined ||
      doc.Criteria.BuildingsAD === selectedAds.buildingsAd;

    return correctForContents && correctForBuildings;
  }
};

export const filterSuccessQuoteDocs = (
  doc,
  quoteId,
  selectedAds,
  paymentFrequency = "monthly"
) => {
  if (
    (doc.Code === "terms" && doc.QuoteId === quoteId) ||
    (doc.Code === "ipid" && doc.QuoteId === quoteId) ||
    (doc.Code === "qas" && doc.QuoteId === quoteId) ||
    (doc.Code === "sdn" && doc.QuoteId === quoteId) ||
    (doc.Code === "sdnnonadvised" && doc.QuoteId === quoteId) ||
    (doc.Code === "suitability" && doc.QuoteId === quoteId) ||
    (doc.Code === "factfindsdn" && doc.QuoteId === quoteId) ||
    (doc.Code === "cofc" && doc.QuoteId === quoteId) ||
    (doc.Code === "quote" &&
      doc.QuoteId === quoteId &&
      doc.Criteria.PaymentFrequency === paymentFrequency.toLowerCase())
  )
    return true;

  if (doc.Code === "multiquote") {
    if (!doc.Criteria) return false;

    const correctForContents =
      doc.Criteria.ContentsAD === undefined ||
      doc.Criteria.ContentsAD === selectedAds.contentsAd;

    const correctForBuildings =
      doc.Criteria.BuildingsAD === undefined ||
      doc.Criteria.BuildingsAD === selectedAds.buildingsAd;

    return correctForContents && correctForBuildings;
  }
};
